import { CompanyDetails } from "./components/CompanyDetails";
import { CompanyBranchesAndSubsidiaries } from "./components/CompanyBranchesAndSubsidiaries";
import { CompanyAnticipatedTransactions } from "./components/CompanyAnticipatedTransactions";
import { CompanyPreferredMailingAddress } from "./components/CompanyPreferredMailingAddress";
import { CompanyPreferredContactInformation } from "./components/CompanyPreferredContactInformation";
import { CompanyContactDetails } from "./components/CompanyContactDetails";
import { CompanyBankingRelationships } from "./components/CompanyBankingRelationships";
import { GA_EVENTS } from "../../utils/ga";

export const STEP_1 = 1;
export const STEP_2 = 2;
export const STEP_3 = 3;
export const STEP_4 = 4;
export const STEP_5 = 5;
export const STEP_6 = 6;
export const STEP_7 = 7;
export const STEP_8 = 8;

export const MAX_COMPANY_NAME_LENGTH = 80;
export const MAX_REGISTRATION_NUMBER_LENGTH = 12;
export const MAX_LICENSE_NUMBER_LENGTH = 20;
export const MAX_YEARS_IN_BUSINESS_LENGTH = 3;
export const MAX_INDUSTRIES_LENGTH = 12;
export const MAX_ADDRESS_FIELD_LENGTH = 50;
export const MAX_ADDRESS_LINE1_FIELD_LENGTH = 10;
export const MAX_PO_BOX_LENGTH = 10;
export const MAX_GLOBAL_INTERMEDIARY_ID_LENGTH = 50;
export const Max_MAKANI_NUMBER_LENGTH = 20;

export const companyInfoSteps = [
  {
    step: STEP_1,
    title: "Company Details",
    component: CompanyDetails,
    eventName: GA_EVENTS.POST_ELIGIBILITY_COMPANY_INFORMATION_DETAILS_CONTINUE
  },
  {
    step: STEP_2,
    title: "Company Contact Details",
    component: CompanyContactDetails,
    eventName: GA_EVENTS.POST_ELIGIBILITY_COMPANY_INFORMATION_CONTACT_CONTINUE
  },
  {
    step: STEP_4,
    title: "Banking Relationships",
    component: CompanyBankingRelationships,
    eventName: GA_EVENTS.POST_ELIGIBILITY_COMPANY_BANKING_RELATIONSHIP_CONTINUE
  },
  {
    step: STEP_5,
    title: "Branches and subsidiaries",
    component: CompanyBranchesAndSubsidiaries,
    eventName: GA_EVENTS.POST_ELIGIBILITY_COMPANY_BRANCHES_CONTINUE
  },
  {
    step: STEP_6,
    title: "Anticipated Transactions",
    component: CompanyAnticipatedTransactions,
    eventName: GA_EVENTS.POST_ELIGIBILITY_COMPANY_ANTICIPATED_TRANSACTIONS_CONTINUE
  },
  {
    step: STEP_7,
    title: "Preferred Mailing Address",
    component: CompanyPreferredMailingAddress,
    eventName: GA_EVENTS.POST_ELIGIBILITY_COMPANY_PREFERRED_MAILING_ADDRESS_CONTINUE
  },
  {
    step: STEP_8,
    title: "Preferred Contact Information",
    component: CompanyPreferredContactInformation,
    eventName: GA_EVENTS.POST_ELIGIBILITY_COMPANY_PREFERRED_CONTACT_INFO_CONTINUE
  }
];
export const WAGE_PROTECTION_OPTIONS = [
  {
    key: "bankName",
    code: "bankName",
    label: "Bank",
    displayText: "Bank",
    value: "Bank",
    subGroup: null
  },
  {
    key: "exchangeHouse",
    code: "exchangeHouse",
    label: "Exchange house",
    displayText: "Exchange house",
    value: "Exchange House",
    subGroup: null
  },
  {
    key: "other",
    code: "other",
    label: "Other",
    displayText: "Other",
    value: "Other",
    subGroup: null
  }
];

export const PERCENTAGE_ANNUAL_INTERVALS = [
  { code: "0", key: "0", value: "0", displayText: "0" },
  { code: "1", key: "1", value: "1", displayText: "1" },
  { code: "10", key: "10", value: "10", displayText: "10" },
  { code: "20", key: "20", value: "20", displayText: "20" },
  { code: "30", key: "30", value: "30", displayText: "30" },
  { code: "40", key: "40", value: "40", displayText: "40" },
  { code: "50", key: "50", value: "50", displayText: "50" },
  { code: "60", key: "60", value: "60", displayText: "60" },
  { code: "70", key: "70", value: "70", displayText: "70" },
  { code: "80", key: "80", value: "80", displayText: "80" },
  { code: "90", key: "90", value: "90", displayText: "90" },
  { code: "100", key: "100", value: "100", displayText: "100 %" }
];
export const SPLIT_OPTIONS = [
  { value: -50, label: "50 % Cash" },
  { value: 50, label: "50 % Credit" }
];
export const SPLIT_BUSINESS_OPTIONS = [
  { value: -50, label: "50 % International" },
  { value: 50, label: "50 % Local" }
];

export const PERCENTAGE_ANNUAL_SALES = "What is % of annual sales within this industry?";
export const SPLIT_BTW_INTERNATIONAL_LOCAL_SALES =
  "What is the split between the company's international and local sales?";
export const SPLIT_BTW_WHOLESALE_RETAIL_TRADE =
  "What is company split between wholesale and retail trade";
export const COMPANY_INFO_PAGE_ID = "companyInfo";
export const IS_VAT_EXEMPT = "Is your company VAT Exempt?";
export const DOES_OUTSOURCE = "Does the company outsource staff?";
export const WAGE_PROTECTION_SYSTEM_ROUTE = "Where is the staff salary (WPS) being routed from?";

export const SHOW_GOOGLE_ADDRESS = "Show address on google maps";
export const YES_NO_OPTIONS = [
  {
    key: "yes",
    code: "yes",
    label: "Yes",
    displayText: "Yes",
    value: "yes",
    subGroup: null
  },
  {
    key: "no",
    code: "no",
    label: "No",
    displayText: "No",
    value: "no",
    subGroup: null
  }
];

export const ACTIVE_PASSIVE_OPTIONS = [
  {
    key: "active",
    code: "active",
    label: "Active",
    displayText: "Active",
    value: "active",
    subGroup: null
  },
  {
    key: "passive",
    code: "passive",
    label: "Passive",
    displayText: "Passive",
    value: "passive",
    subGroup: null
  }
];
const Manufacturing = "MFG";
const Service = "SER";
const Transport = "TSC";
const GENERAL_TRADING = "GT";
const RETAIL_TRADING = "RT";
const WHOLESALE_TRADING = "WST";

export const INDUSTRY_OPTIONS = [Manufacturing, Service, Transport];
export const TRADING_TYPES = [GENERAL_TRADING, RETAIL_TRADING, WHOLESALE_TRADING];

export const internationalType = true;
export const buyType = true;

export const PREMISES_TYPE_OTHER_OPTION_CODE = "T6";

export const NUMBEROFDays = "0-45";
export const YEAR_MONTH_COUNT = 12;
export const DEFAULTAMOUNT = 1;
export const PLACEHOLDER = "9999999999";
